import { psaInitialFormData } from "@/utils/enum";
import { createSlice } from "@reduxjs/toolkit";

export interface PsaFilterState {
  schools: any;
  grades: any;
  currentPage: any;
  psaEventsCount: any;
  psaEvents: [];
  psaSearchData: any;
  studentId: any;
  boardId: any;
  dob: any;
  gender: any;
  enrollmentNumber: any;
  firstName: any;
  lastName: any;
  email: any;
  phoneNumber: any;
  studentType: any;
  schoolName: any;
}

const initialState: PsaFilterState = {
  schools: null,
  grades: null,

  dob: "",
  gender: "",
  enrollmentNumber: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  studentType: "",
  schoolName: "",
  studentId: "",
  boardId: "",
  currentPage: 1,
  psaEventsCount: 0,
  psaEvents: [],
  psaSearchData: { ...psaInitialFormData },
};

const psaFilterSlice = createSlice({
  name: "psaFilter",
  initialState,
  reducers: {
    addFilter: (state, action) => {
      return { ...state, ...action.payload };
    },
    setPsaEventsCount: (state, action) => {
      state.psaEventsCount = action.payload;
    },
    setPsaEvents: (state, action) => {
      state.psaEvents = action.payload;
    },
    setPsaSearchData: (state, action) => {
      state.psaSearchData = action.payload;
    },
    clearPsaData: (state) => {
      return {
        ...initialState,
      };
    },
    clearFilters: (state) => {
      state.schools = null;
      state.grades = null;
      state.dob = "";
      state.gender = "";
      state.enrollmentNumber = "";
      state.firstName = "";
      state.lastName = "";
      state.email = "";
      state.phoneNumber = "";
      state.studentType = "";
      state.schoolName = "";
      state.psaEvents = [];
      state.studentId = "";
      state.boardId = "";
    },
  },
});

export const {
  addFilter,
  setPsaEventsCount,
  setPsaEvents,
  setPsaSearchData,
  clearPsaData,
  clearFilters,
} = psaFilterSlice.actions;
export const psaFilterItems = (state: any) => state.psaFilter;
export default psaFilterSlice.reducer;
